var path = '/app/components/commentBox/commentbox.html';
var html = " <div class=mt-3 ng-if=ctrl.showCommentBox> <textarea class=form-control id=inputProjectComment rows=5 ng-model=ctrl.commentBody autofocus></textarea> <div class=\"d-flex justify-content-between align-items-center mt-3\"> <small class=text-muted>* All comments are subject to review under our <a href=#>Terms & Conditions</a>.</small> <button type=button class=\"btn btn-primary\" ng-click=ctrl.postComment() ng-disabled=\"ctrl.postingComment || ctrl.commentBody.length === 0\">{{ ctrl.postingComment ? 'Posting ' : 'Post'}}<i ng-if=ctrl.postingComment class=\"fa fa-circle-o-notch fa-spin-fast fa-fw\"></i></button> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/commentBox/commentbox.html
// module id = 318
// module chunks = 0